import React, { useEffect, useState } from 'react';
import { cellRendererCheck, dateFormate, currencyFormat } from 'utils/columns';
import ReactStrapTable from 'components/reactStrapTable';
import { ModuleAccess } from 'utils/moduleaccess';
import { Button, Modal, ModalBody } from 'reactstrap';
import Loader from 'components/Loader';
import Confirm from 'components/Confirm';
import { use } from 'react';
import { cloneDeep } from 'lodash';

let errorBackupData = [];
let isRole = ["GWPHA", "GWPHU"];
let flag = false;
let packageOrdered = 0;
let updatedPackageOrdered = 0;
let id = 0;
let errorMessage = "Quantity must be equal to or less than the quantity ordered.."
const OrderDetailsTable = ({
  tenantID,
  data,
  loading,
  onExport,
  filters,
  totalSize,
  onPageChange,
  refetch,
  setLoading,
  onQtyChange,
  onSearchColumnFilters,
  handleSaveButton,
  savebtnDisabled,
  qtyOrdCheck,
  reset,
  handleCancelChange,
  accountype
}) => {
  const [state, updateState] = useState({
    tableData: [],
    backUpData: [],
    filters: filters,
    errors: {},
  });
  const [tempData, setTempData] = useState(0);
  const [isConfirm, setConfirm] = useState(false);
  const [data1, setData] = useState();
  const [conformLoading, setConformLoading] = useState(false);
  const [selectedValue, setSelectedValue] = useState([]);
  const pharmaforce = sessionStorage.getItem("pharmaforce");
  const { token_type, access_token, profile } =
    JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
  const { roles } = profile || {};
  console.log(roles, "roles")
  var con = isRole.includes(roles);
  console.log(con, "con")

  const [hasExportPermission, setHasExportPermission] = useState(false);
  useEffect(() => {
    setState({ tableData: data, backUpData: data });
    flag = false;
    packageOrdered = 0;
    updatedPackageOrdered = 0;
    id = 0;
    errorBackupData = data;
  }, [data]);
  const setState = (obj) => updateState(pre => ({ ...pre, ...obj }));

  useEffect(() => {
    setState({ filters: filters });
  }, [filters]);

  useEffect(() => {
    setHasExportPermission(ModuleAccess("PO", "PODETAILSEXP"));
  }, []);

  const hasPermission = (code) => {
    return ModuleAccess("PO", code);
  };

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      setState({
        filters: filter,
      });
      let colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    setState({
      filters: filter,
    });
    onPageChange(filter);
  };

  const handleFilterCancel = () => {
    refetch(true);
  };

  const handleSearchColumnFilters = (colFilter) => {
    if (onSearchColumnFilters) {
      const filter = { ...state.filters, filters: colFilter, currentPage: 1 };
      onSearchColumnFilters(filter);
      setState({
        filters: filter,
      });
    }
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      setState({
        filters: filter,
      });
      let colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      setState({
        filters: filter,
      });
      onPageChange(filter);
    }
  };

  const handleSort = (filter, hasColFilter) => {
    setState({
      filters: filter,
    });
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };


  const { filters: colFilter, backUpData } = state;


  const columns = [
    {
      dataField: 'poItemEditAction',
      text: 'Options',
      sort: false,
      width: 100,
      show: true,
      hidecolFilter: true,
      action: true,
      cellRenderer: (rowData) => {
        // Ensure that poItemEditAction has a default value of "A" if it's undefined
        const poItemEditAction = rowData.poItemEditAction ?? "A";

        const handleCheck = (event, rowData) => {
          const value = event.target.value;
          rowData.poItemEditAction = value; // Update rowData with the selected value

          setSelectedValue((prevState) => {
            const rowIndex = prevState.findIndex((item) => item.ndc === rowData.drugID);
            const updatedRow = { ...rowData, poItemEditAction: value };

            if (rowIndex > -1) {
              const updatedState = [...prevState];
              updatedState[rowIndex] = updatedRow;
              return updatedState;
            } else {
              return [...prevState, updatedRow];
            }
          });

          // Now call onQtyChange with the updated rowData, including poItemEditAction
          onQtyChange(rowData, false); // Pass the updated rowData to onQtyChange
        };

        if (hasPermission("PODC") && (accountype == 1)) {
          if (rowData.itemStatusID == 6010) {
            return (
              <div style={{ display: "flex" }}>
                <label style={{ display: "flex", alignItems: "center", marginRight: "5px" }}>
                  <input
                    type="radio"
                    name={`rb${rowData.drugID}`} // Unique name for each row
                    value="A"
                    checked={poItemEditAction === "A"} // Ensures the correct radio button is selected
                    onChange={(e) => handleCheck(e, rowData)}
                  />
                  <span style={{ paddingLeft: "2px" }}>A</span>
                </label>
                <label style={{ display: "flex", alignItems: "center" }}>
                  <input
                    type="radio"
                    name={`rb${rowData.drugID}`} // Unique name for each row
                    value="C"
                    checked={poItemEditAction === "C"} // Ensures the correct radio button is selected
                    onChange={(e) => handleCheck(e, rowData)}
                  />
                  <span style={{ paddingLeft: "2px" }}>C</span>
                </label>
              </div>
            );
          }
          else if (
            rowData.itemStatusID == 6020 ||
            rowData.itemStatusID == 6040 ||
            rowData.itemStatusID == 6050 ||
            rowData.itemStatusID == 6060 ||
            rowData.itemStatusID == 6080
          ) {
            return (null)
          }
        }
      },
    },
    {
      dataField: "ndc",
      text: "NDC",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: "drugName",
      text: "Drug Name",
      sort: false,
      width: 280,
      show: true,
      inputType: "text",
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      hideColFilter: true,
    },
    {
      dataField: "drugManufacturerName",
      text: "Manufacturer",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      hideColFilter: true,
    },
    {
      dataField: "packageSize",
      text: "Package Size",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      hideColFilter: true,
    },
    {
      dataField: 'itemStatus',
      text: 'Item Status',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: 'statusTypeCode',
      text: 'Status Type Code',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: 'statusCodeDescription',
      text: 'Status Code Description',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: "packageOrdered",
      text: "Qty Ord.",
      sort: true,
      width: 140,
      show: true,
      inputType: "number",
      cellRenderer: (rowData, col) => {

        const handleEditChange = (newValue, rowData) => {

          if (id != rowData.poItemID) {
            flag = false;
          }
          if (flag == false) {
            packageOrdered = rowData.packageOrdered;
            id = rowData.poItemID;
          }
          flag = true;
          if (newValue !== "") {
            const regPtrn = /^[0-9\b]+$/;
            if (!regPtrn.test(newValue)) {
              return;
            }
            if (parseFloat(newValue) > packageOrdered) {
              handleSaveButton(true);
              updateErrorMessage(rowData);
              errorBackupData = errorBackupData.map(obj => obj.poItemID === rowData.poItemID ? { ...obj, ndc: true } : obj);

            } else {
              const payload = cloneDeep(rowData);
              handleSaveButton(false);
              payload.packageOrdered = parseFloat(newValue);
              onQtyChange(payload, true);
              ReupdateErrorMessage(payload);
              errorBackupData = errorBackupData.map(obj => obj.poItemID === rowData.poItemID ? { ...obj, ndc: false } : obj);
            }
          }


        };


        const hasError = state.errors?.[rowData.drugID];

        const qtyOrdCellRendererCheck = (rowData, col) => (
          <div>
            <input
              id={"txt" + rowData.drugID}
              type="text"
              defaultValue={rowData.packageOrdered}
              onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
              onChange={(e) => { handleEditChange(e.target.value, rowData) }}
              style={{ width: "115px" }}
            />
            {hasError && (
              <div className="text-danger font-size-12" id={`error${rowData.drugID}`}>
                {hasError}
              </div>
            )}
          </div>
        );

        return qtyOrdCheck
          ? qtyOrdCellRendererCheck(rowData, col)
          : cellRendererCheck(rowData[col.dataField]);
      },

    },

    {
      dataField: "packageAcknowledged",
      text: "Qty Ack.",
      sort: true,
      width: 140,
      show: true,
      inputType: "number",
      cellRenderer: (rowData) => cellRendererCheck(rowData.packageAcknowledged),
    },
    {
      dataField: "packageInvoiced",
      text: "Qty Billed",
      sort: true,
      width: 140,
      show: true,
      inputType: "number",
      cellRenderer: (rowData) => cellRendererCheck(rowData.packageInvoiced),
    },

    {
      dataField: 'acknowledgedDate',
      text: 'Ack. Date',
      sort: false,
      width: 140,
      show: true,
      inputType: 'date',
      hideColFilter: true,
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
      showColumn: true
    },

    {
      dataField: 'billedDate',
      text: 'Billed Date',
      sort: false,
      width: 140,
      show: true,
      inputType: 'date',
      hideColFilter: true,
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
      showColumn: true
    },
    {
      dataField: "orderedPackagePrice",
      text: "Ordered Package Price",
      sort: true,
      width: 140,
      show: con == true ? false : true,
      hideColFilter: con == true ? true : false,
      inputType: "number",
      cellRenderer: (rowData) => currencyFormat(rowData.orderedPackagePrice),
    },
    {
      dataField: "orderedTotalPrice",
      text: "Total Ordered Price",
      sort: false,
      width: 140,
      show: con == true ? false : true,
      hideColFilter: con == true ? true : false,
      inputType: "number",
      hideColFilter: true,
      cellRenderer: (rowData) => currencyFormat(rowData.orderedTotalPrice),
    },
    {
      dataField: "acknowledgedPackagePrice",
      text: "Ack. Package Price",
      sort: true,
      width: 140,
      show: con == true ? false : true,
      hideColFilter: con == true ? true : false,
      inputType: "number",
      cellRenderer: (rowData) => currencyFormat(rowData.acknowledgedPackagePrice),
    },
    {
      dataField: "acknowledgedTotalPrice",
      text: "Total Ack. Price",
      sort: false,
      width: 140,
      show: con == true ? false : true,
      hideColFilter: con == true ? true : false,
      inputType: "number",
      hideColFilter: true,
      cellRenderer: (rowData) => currencyFormat(rowData.acknowledgedTotalPrice),
    },
    {
      dataField: "invoicedPackagePrice",
      text: "Billed Package Price ",
      sort: true,
      width: 140,
      show: con == true ? false : true,
      hideColFilter: con == true ? true : false,
      inputType: "number",
      cellRenderer: (rowData) => currencyFormat(rowData.invoicedPackagePrice),
    },
    {
      dataField: "invoicedTotalPrice",
      text: "Total Billed Price",
      sort: false,
      width: 140,
      show: con == true ? false : true,
      hideColFilter: con == true ? true : false,
      inputType: "number",
      hideColFilter: true,
      cellRenderer: (rowData) => currencyFormat(rowData.invoicedTotalPrice),
    },
    {
      dataField: "itemInvoiceNumber",
      text: "Invoice #",
      sort: false,
      width: 140,
      show: true,
      inputType: "number",
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.itemInvoiceNumber),
    }

  ];

  const updateErrorMessage = (rowData) => (
    updateState((prevState) => {
      const newErrors = {
        ...prevState.errors,
        [rowData.drugID]: errorMessage,
      }
      return {
        ...prevState,
        errors: newErrors,
      };
    })
  );

  const ReupdateErrorMessage = (rowData) => {
    handleSaveButton(false);
    updateState((prevState) => {
      const updatedErrors = { ...prevState.errors };
      delete updatedErrors[rowData.drugID];
      return {
        ...prevState,
        errors: updatedErrors
      };
    })
  };

  useEffect(() => {
    function checkNameInArray(array, errorMessage) {
      return array.some(obj => obj.ndc === errorMessage);
    }

    if (checkNameInArray(errorBackupData, true)) {
      handleSaveButton(true);

    }

    else {
      handleSaveButton(false)

    }
  }, [errorBackupData])


  useEffect(() => {
    if (handleCancelChange == true) {
      updateState((prevState) => {
        handleSaveButton(false);
        const updatedErrors = {};
        delete updatedErrors[""];
        return {
          ...prevState,
          errors: updatedErrors,
          addErrors: []
        };
      })
    }
  }, [handleCancelChange])

  return (

    <div>

      <h5 className="f-16 text-primary font-weight-700"> PO Items Count ({totalSize}) </h5>
      <hr/>

      <div
        className='table-card scroll-table position-relative border-0 rounded pt-0'
        fixed-height={data.length > 0 ? "fixed-height" : "default"}
      >
        <ReactStrapTable
          id='inventory-table'
          fixedColumn
          data={backUpData}
          loading={loading}
          columns={columns}
          hasScrollArrow={false}
          onPageSizeChange={onPageSizeChange}
          pageSize={colFilter.pageSize}
          onExport={onExport}
          hasPagination={false}
          onPageChange={onHandlePageChange}
          currentPage={colFilter.currentPage}
          totalRecords={totalSize}
          filters={colFilter}
          handleSort={handleSort}
          onFilterCancel={handleFilterCancel}
          onSearchColumnFilters={handleSearchColumnFilters}
          hasExportPermission={hasExportPermission}
          pageSizeRemove={false}
        />

      </div>



    </div>

  );


};

export default OrderDetailsTable;
